// extracted by mini-css-extract-plugin
export default {"root":"interest_item-module___root___c66288b3","item":"interest_item-module___item___adf003e9","title":"interest_item-module___title___e566e6cc"};